import React from "react"
import { useTranslation } from "react-i18next"

import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { ProductPositionTableCell } from "widgets/product-position-table/ProductPositionTableCell"
import { PRODUCT_POSITION_TABLE_CR_HEADER_ID } from "widgets/product-position-table/ProductPositionTableHeader"
import { ProductPositionRowCellProps } from "widgets/product-position-table/rows/product-position/ProductPositionTableProductPositionRowView"

interface ProductPositionRowClarificationRequestCellProps
  extends ProductPositionRowCellProps {
  hasClarificationRequest?: boolean | null
}

export const ProductPositionRowClarificationRequestCell = React.memo(
  React.forwardRef(
    (
      {
        hasClarificationRequest,
        ...rest
      }: ProductPositionRowClarificationRequestCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      const { t } = useTranslation()

      return (
        <ProductPositionTableCell
          ref={ref}
          aria-labelledby={PRODUCT_POSITION_TABLE_CR_HEADER_ID}
          className="clarification-request"
          {...rest}
        >
          {hasClarificationRequest ? (
            <>
              <span className="visually-hidden">
                {t("ClarificationRequest.Column.Yes")}
              </span>
              <Icon
                name={IconName.CLARIFICATION_REQUEST}
                size={IconSize.SMALL}
              />
            </>
          ) : (
            <span className="visually-hidden">
              {t("ClarificationRequest.Column.No")}
            </span>
          )}
        </ProductPositionTableCell>
      )
    }
  )
)
